"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowEventHandler = void 0;
var _Channel = require("../dragon/common/enums/Channel");
var _Orientation = require("../dragon/common/enums/Orientation");
var _types = require("../dragon/store/config/types");
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
var _errorReporter = require("./errorReporter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WindowEventHandler = exports.WindowEventHandler = /*#__PURE__*/function () {
  function WindowEventHandler() {
    _classCallCheck(this, WindowEventHandler);
    window.addEventListener("resize", this._resize.bind(this));
    this._resize();

    // NOTE errors or exceptions that are not caught by a try/catch block will be caught here.
    // but NOT errors in proimises, for that we need to use window.onunhandledrejection

    window.onunhandledrejection = function (event) {
      var _event$reason;
      (0, _errorReporter.reportError)((event === null || event === void 0 || (_event$reason = event.reason) === null || _event$reason === void 0 ? void 0 : _event$reason.stack) || (event === null || event === void 0 ? void 0 : event.reason) || event);
    };
    window.onerror = function (message, source, lineno, colno, error) {
      if (error) message = error.stack;
      //ga('send', 'event', 'window.onerror', message, navigator.userAgent);
      (0, _errorReporter.reportError)(message);
    };
    document.addEventListener("visibilitychange", function (e) {
      if (document.hidden) _Core["default"].dispatch({
        type: _types.WINDOW_BLUR
      });else _Core["default"].dispatch({
        type: _types.WINDOW_FOCUS
      });
    });
    _Core["default"].resize = this._resize;
  }
  return _createClass(WindowEventHandler, [{
    key: "_resize",
    value: function _resize() {
      var state = _Core["default"].getState();
      var minratio = _Core["default"].getState().config.minDesktopRatio;
      var fixedRatio = _Core["default"].getState().config.fixedDesktopRatio;
      var _width = window.innerWidth;
      var _height = window.innerHeight;

      // Desktop game ratio enforcement, the game needs to have an actuall config for it.
      if (state.config.channel == _Channel.Channel.Desktop) {
        if (minratio) {
          if (window.innerWidth / window.innerHeight < minratio) {
            _height = _width / minratio;
          }
        }
        if (fixedRatio) {
          _width = _height * fixedRatio;
          _height = _width / fixedRatio;
        }
      }
      document.body.classList.remove(_Orientation.Orientation.Portrait, _Orientation.Orientation.Landscape, "channel-mobile", "channel-desktop");
      document.body.classList.add("channel-" + state.config.channel);
      var orientation = _Orientation.Orientation.Landscape;
      if (window.innerHeight > _width) {
        orientation = _Orientation.Orientation.Portrait;
      }
      var scale = _height / 900;
      var scaleHd = _height / 1080;

      //#region IOS safari adressbar, add to state
      var bodyHeight = document.documentElement.clientHeight;
      var windowHeight = window.innerHeight;
      var bodyHeightOffset = bodyHeight - windowHeight;
      //#endregion

      document.body.classList.add(orientation);
      _Core["default"].dispatch({
        type: _types.WINDOW_RESIZE,
        payload: {
          scaleFactorHd: scaleHd,
          scaleFactor: scale,
          height: _height,
          width: _width,
          orientation: orientation,
          ratio: _width / _height,
          bodyHeightOffset: bodyHeightOffset
        }
      });
    }
  }]);
}();
//# sourceMappingURL=windowEventHandler.js.map